import { txUrl } from "../lib/config";
import { toast, useToasts } from "../lib/toast";

export function Toasts() {
  const list = useToasts();
  return (
    <div className="toasts" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`} onClick={() => toast.dismiss(t.id)}>
          <div>{t.text}</div>
          {t.hash && (
            <a href={txUrl(t.hash)} target="_blank" rel="noreferrer">
              View on explorer
            </a>
          )}
        </div>
      ))}
    </div>
  );
}
